/** @type {Map<number, import('../webgl/Texture').Texture>} */
export const textures = new Map()
